import type { InfiniteData, InfiniteQueryObserverResult } from '@tanstack/svelte-query';

export function getInfiniteData<T, K>({
	query,
	transform
}: {
	query: InfiniteQueryObserverResult<InfiniteData<T, unknown>, Error>;
	transform: (data: T) => K[];
}) {
	return query.data?.pages.reduce((acc: K[], curr) => [...acc, ...transform(curr)], []);
}
